import { t } from 'i18next';
import styled from 'styled-components';

import { useLocalize } from '@treams/treams-hooks';
import { CompetencyGoal } from '@treams/treams-network';
import { tokens } from '@treams/treams-ui';

import GoalSkillScoreIndex from './GoalSkillScoreIndex';

const StyledGoalSkillScore = styled.section`
	min-width: 200px;
	display: flex;
	flex-direction: column;
`;

const GoalSkillScoreBox = styled.div`
	border: 1px solid ${tokens.border.subtle};
	border-radius: 5px;
	background: ${({ theme }) => theme.colors.white};
	display: flex;
	flex-direction: column;
	justify-content: center;
	overflow: hidden;
`;

const GoalSkillScoreDescription = styled.div`
	background: ${tokens.surface.secondary};
	padding: 16px;
	display: flex;
	flex-direction: column;
	row-gap: 8px;
	border-bottom: 1px solid ${tokens.border.subtle};
`;

const Label = styled.h3`
	font-size: 12px;
	line-height: 16px;
	margin: 0 0 2px;
	font-weight: normal;
`;

const Description = styled.p`
	font-size: 16px;
	line-height: 16px;
	font-weight: bold;
`;

export default function GoalSkillScore({ goalCompetency }: { goalCompetency: CompetencyGoal }) {
	const { localize } = useLocalize();

	const competency = goalCompetency?.competency;
	const targetCompetencyLevel =
		goalCompetency && competency?.competencyLevelSet.levels[goalCompetency?.competencyLevelIndex];

	return (
		<StyledGoalSkillScore>
			<GoalSkillScoreBox>
				<GoalSkillScoreDescription>
					<div>
						<Label>{t('developmentPlan.index.goalSkillScore.competencyTitle')}</Label>
						<Description>{localize(competency.title).text}</Description>
					</div>
					{targetCompetencyLevel && (
						<div>
							<Label>{t('developmentPlan.index.goalSkillScore.targetLevel')}</Label>
							<Description>{localize(targetCompetencyLevel.title).text}</Description>
						</div>
					)}
				</GoalSkillScoreDescription>
				<GoalSkillScoreIndex goalCompetency={goalCompetency} />
			</GoalSkillScoreBox>
		</StyledGoalSkillScore>
	);
}
